import React, { Fragment } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import { useHistory } from 'react-router-dom';
import { isMobile } from 'react-device-detect';
import useTitle from 'hooks/useTitle';

const useStyles = makeStyles((theme) => ({
  buttons: {
    display: 'grid',
    gridTemplateColumns: isMobile ? '1fr 1fr' : '1fr 1fr 1fr 1fr',
    gridGap: theme.spacing(1),
  },
}));

const UsersActionsButtons = () => {
  useTitle('مدیریت کاربران')
  const history = useHistory();
  const classes = useStyles();

  const handleClick = (role) => {
    history.push(`/protected/admin/users/add/${role}`);
  };

  return (
    <div className={classes.buttons}>
      <Button
        variant="contained"
        size="small"
        color="secondary"
        onClick={() => handleClick('operator')}
      >
        افزودن کارشناس حمل
      </Button>
      <Button variant="contained" size="small" color="secondary">
        افزودن باربری
      </Button>
      <Button
        variant="contained"
        size="small"
        color="secondary"
        onClick={() => handleClick('driver')}
      >
        افزودن راننده
      </Button>
      <Button
        variant="contained"
        size="small"
        color="secondary"
        onClick={() => handleClick('customer')}
      >
        افزودن صاحب‌بار
      </Button>
    </div>
  );
};

export default UsersActionsButtons;
